var _ = require('underscore');
var SoaCollection = require('bunsen/collections/SoaCollection');
var EcomCharges = SoaCollection.extend();

var EcomCharge = require('bunsen/models/ecomm/EcomCharge');

_.extend(EcomCharges.prototype, {
    model : EcomCharge
});

module.exports = EcomCharges;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/ecomm/EcomCharges.js
// module id = 157
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54